import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import "../styles/forumPost.css";

export default function ForumPost({ id, name, profile_picture, timeAgo, text, images, likes, comments, commentsCount, isLiked }) {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [openReplies, setOpenReplies] = useState({});

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isPostLiked, setIsPostLiked] = useState(isLiked || false);
    const [showComments, setShowComments] = useState(false);
    const [newComment, setNewComment] = useState("");
    const [commentList, setCommentList] = useState(comments || []);


    // ALAP ADATOK LEKÉRÉSE PL LIKEOLTA-e MÁR
    useEffect(() => {
        fetch(`https://focifanatik.hu/api/profile_API/components/isPostLiked.php?targetPost=${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setIsLoggedIn(data.isLoggedIn);
                    setIsPostLiked(data.isLiked);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, [])




    // LIKEOLÁS HOZZÁADÁS/ELVÉTELE
    const handleLike = () => {

        fetch(`https://focifanatik.hu/api/profile_API/components/likePost.php?targetPost=${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    if (data.liked == true) {
                        setIsPostLiked(true);
                    }
                    else if (data.liked == false) {
                        setIsPostLiked(false);
                    }
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));

    }


    /* -------------------------------------------------- KOMMENT HOZZÁADÁSA ----------------------------------------- */
    const handleAddComment = () => {
        if (!newComment.trim()) return;


        // MEG KELL MÉG CSINÁLNI HOGY LEHESSEN EGY KOMMENTRE REAGÁLNI NAGYON FONTOS!!!!!!
        // fetch("https://focifanatik.hu/api/profile_API/components/commentPost.php", {
        //     method: "POST",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify({
        //         post_id: id,
        //         text: newComment,

        //     })
        // })

        // setCommentList([newCom, ...commentList]);
        setNewComment("");
    };


    /* -------------------------------------------------- BAL, JOBB NYIL LAPOZÁS ----------------------------------------- */
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (selectedIndex === null) return;

            if (e.key === "ArrowLeft") {
                setSelectedIndex((prev) =>
                    prev === 0 ? images.length - 1 : prev - 1
                );
            }

            if (e.key === "ArrowRight") {
                setSelectedIndex((prev) =>
                    prev === images.length - 1 ? 0 : prev + 1
                );
            }

            if (e.key === "Escape") {
                setSelectedIndex(null);
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedIndex, images]);

    const toggleReplies = (commentId) => {
        setOpenReplies(prev => ({
            ...prev,
            [commentId]: !prev[commentId]
        }));
    };

    const getReplies = (commentId) => {
        return commentList.filter(c => c.parent_comment_id === commentId);
    };

    return (
        <div className='forumPage-post'>

            <div className='forumPage-post-topBar'>
                <img src={`https://focifanatik.hu/${profile_picture}`} />
                <div className='forumPage-post-topBar-texts'>
                    <span>{name}</span>
                    <span>{timeAgo}</span>
                </div>
            </div>
            <div className='forumPage-post-content'>
                <span>{text}</span>

                {images && images.length > 0 && (
                    <div className='postImages'>
                        {images.map((img, index) => (
                            <img key={index} src={img.img_url || `https://focifanatik.hu/${img.image_url}`} alt="post" onClick={() => setSelectedIndex(index)} />
                        ))}
                    </div>
                )}

            </div>

            {showComments && (
                <div className="commentsSection">

                    <div className="addComment">
                        <input
                            type="text"
                            placeholder="Írj kommentet..."
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                        />
                        <button onClick={handleAddComment}>Küldés</button>
                    </div>

                    <div className="commentList">
                        {commentList
                            .filter(com => !com.parent_comment_id)
                            .map((com) => (

                                <div key={com.id} className="commentItem">

                                    {/* FŐ KOMMENT */}
                                    <div className='commentItem-parentComment'>
                                        <span className="commentName"><Link to={`/profilom/${com.username}`}>{com.username}</Link>:</span>
                                        <span className="commentText">{com.text}</span>

                                        {getReplies(com.id).length > 0 && (
                                            <button
                                                className="toggleRepliesBtn"
                                                onClick={() => toggleReplies(com.id)}
                                            >
                                                {openReplies[com.id]
                                                    ? "Elrejtés"
                                                    : `Válaszok (${getReplies(com.id).length})`}
                                            </button>
                                        )}
                                    </div>

                                    {/* LENYÍLÓ VÁLASZOK */}
                                    {openReplies[com.id] && (
                                        <div className="replies">
                                            {getReplies(com.id).map(reply => (
                                                <div key={reply.id} className="replyItem">
                                                    <span className="commentName"><Link to={`/profilom/${reply.username}`}>{reply.username}:</Link></span>
                                                    <span className="commentText">{reply.text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                </div>

                            ))}
                    </div>

                </div>
            )}

            <div className='forumPage-post-content-actions'>
                <div className={`forumPage-post-content-actions-Like ${isPostLiked ? "isPostLikedGreen" : ""}`} onClick={handleLike}>
                    <i class="bi bi-heart"></i>
                    <p>{likes}</p>
                </div>

                <div className='forumPage-post-content-actions-Comment' onClick={() => setShowComments(!showComments)} >
                    <i class="bi bi-chat"></i>
                    <p>{commentsCount}</p>
                </div>
            </div>

            {/* --------------------------------------------------------------------- KÉPEK MEGNYITÁSA -------------------------------------------------------------- */}
            {selectedIndex !== null && (
                <div className="imageModal" onClick={() => setSelectedIndex(null)}>

                    <button
                        className="prevBtn"
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedIndex((prev) =>
                                prev === 0 ? images.length - 1 : prev - 1
                            );
                        }}
                    >
                        <i class="bi bi-arrow-left-circle"></i>
                    </button>

                    <img
                        src={images[selectedIndex].url || `https://focifanatik.hu/${images[selectedIndex].image_url}`}
                        alt="big"
                    />

                    <button
                        className="nextBtn"
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedIndex((prev) =>
                                prev === images.length - 1 ? 0 : prev + 1
                            );
                        }}
                    >
                        <i class="bi bi-arrow-right-circle"></i>
                    </button>

                </div>
            )}



        </div>
    )
}
